export const NAV_STYLES = { backgroundColor: '#fff' };
